import { createContext } from "react";

export const OfertasDetContext = createContext()
export const OfertasDetFormContext = createContext()
export const OfertasDetReportContext = createContext()